module.exports = __webpack_public_path__ + "static/media/2_mobile.d8cbe2e2.jpg";